export default __webpack_public_path__ + "static/media/telebirr.24c4b4fa.jpg";